const formDisabled = () => {
  const agreementCheckbox = document.querySelector('input[name="agree"]')
  const submitButton = document.querySelector('button[type="submit"]')
  /*
   * 利用規約同意時にsubmitボタンを有効化
   */
  if (agreementCheckbox) {
    submitButton.disabled = true
    agreementCheckbox.addEventListener('change', function () {
      submitButton.disabled = !agreementCheckbox.checked
    })
  }
}

export { formDisabled }
